// Utility to get color name from hex code
export const getColorName = (hex: string): string => {
    const colors: Record<string, string> = {
        '#000000': 'Черный',
        '#FFFFFF': 'Белый',
        '#FF0000': 'Красный',
        '#00FF00': 'Зеленый',
        '#0000FF': 'Синий',
        '#FFFF00': 'Желтый',
        '#FF00FF': 'Пурпурный',
        '#00FFFF': 'Голубой',
        '#FFA500': 'Оранжевый',
        '#800080': 'Фиолетовый',
        '#FFD700': 'Золотой',
        '#C0C0C0': 'Серебряный',
        '#808080': 'Серый',
        '#A52A2A': 'Коричневый',
        '#FFC0CB': 'Розовый',
        '#00FF7F': 'Весенне-зеленый',
        '#4B0082': 'Индиго',
        '#FF6347': 'Томатный',
        '#40E0D0': 'Бирюзовый',
        '#EE82EE': 'Фиалковый',
        '#F5DEB3': 'Пшеничный',
        '#F0F8FF': 'Лазурный',
        '#FAEBD7': 'Античный белый',
        '#7FFFD4': 'Аквамариновый',
        '#F5F5DC': 'Бежевый',
        '#FFE4C4': 'Бисквитный',
        '#8B4513': 'Седло-коричневый',
        '#DEB887': 'Древесно-коричневый',
        '#5F9EA0': 'Кадетский синий',
        '#D2691E': 'Шоколадный',
        '#FF7F50': 'Коралловый',
        '#6495ED': 'Васильковый',
        '#DC143C': 'Малиновый',
        '#00008B': 'Темно-синий',
        '#008B8B': 'Темно-голубой',
        '#B8860B': 'Темно-золотой',
        '#A9A9A9': 'Темно-серый',
        '#006400': 'Темно-зеленый',
        '#BDB76B': 'Темный хаки',
        '#8B008B': 'Темно-пурпурный',
        '#556B2F': 'Темный оливково-зеленый',
        '#FF8C00': 'Темно-оранжевый',
        '#9932CC': 'Темная орхидея',
        '#8B0000': 'Темно-красный',
        '#E9967A': 'Темный лосось',
        '#8FBC8F': 'Темный морской зеленый',
        '#483D8B': 'Темный сланцево-синий',
        '#2F4F4F': 'Темный сланцево-серый',
        '#00CED1': 'Темно-бирюзовый',
        '#9400D3': 'Темно-фиолетовый',
        '#FF1493': 'Темно-розовый',
        '#00BFFF': 'Темно-небесно-синий',
        '#696969': 'Тускло-серый',
        '#1E90FF': 'Доджер синий',
        '#B22222': 'Огнеупорный кирпич',
        '#228B22': 'Лесной зеленый',
        '#DCDCDC': 'Гейнсборо',
        '#F8F8FF': 'Призрачно-белый',
        '#DAA520': 'Золотарник',
        '#ADFF2F': 'Зелено-желтый',
        '#808000': 'Оливковый',
        '#800000': 'Бордовый',
        '#000080': 'Темно-синий',
        '#008000': 'Зеленый',
        '#008080': 'Чирок',
    };

    const upperHex = hex.toUpperCase();
    
    // Exact match
    if (colors[upperHex]) {
        return colors[upperHex];
    }

    // Return hex if no match found
    return hex;
};
